export default {
  // 取得資料讀取狀況
  allDataLoaded(state) {
    if (
      state.commonColumnData != null &&
      state.carouselData != null &&
      state.newsData != null &&
      state.newsCategoryData != null &&
      state.categoryData != null &&
      state.productData != null &&
      state.zipCodeData != null &&
      state.paymentData != null &&
      state.shipwayData != null &&
      state.menuCategoryData != null &&
      state.videoData != null &&
      state.videoCategoryData != null &&
      state.pageMetaData != null &&
      state.brandData != null
    ) {
      return true;
    } else {
      return false;
    }
  },
  // 取得指定分類的商品
  menuProductData: (state) => (categoryID) => {
    if (state.productData == null) {
      return null;
    }
    if (categoryID == "all" || categoryID == "") {
      return state.productData;
    } else {
      return state.productData.filter((item) => {
        return item.Menu.filter((menu) => menu.MenuID == categoryID).length > 0;
      });
    }
  },
  // 取得圖片完整路徑
  imageUrl: () => (url) => {
    return process.env.VUE_APP_BASE_API + url;
  },
  // 取得頁面meta資料
  pageMetaData: (state) => (title) => {
    const metaData = state.pageMetaData.find((item) => item.PageTitle == title);
    return metaData != null ? metaData : null;
  },
  // 取得客製化商品價錢
  productCustomPrice: () => (shopCartItem) => {
    let changePrice = 0;
    // 讀取客製化商品的『價格異動資料』陣列
    shopCartItem.productData.CustomGoodsChangePrice.forEach((changeItem) => {
      let matchCount = 0;
      let changeIDList = changeItem.CustomSpecID;
      // 若『價格異動資料』類行為字串，則先分割為陣列
      if (typeof changeItem.CustomSpecID === "string") {
        changeIDList = changeItem.CustomSpecID.split(",");
      }

      // 判斷與目前選擇之選項是否完全相符
      changeIDList.forEach((id) => {
        shopCartItem.activeOption.indexOf(id) != -1 ? (matchCount += 1) : "";
      });

      // 若『價格異動資料』的選項ID陣列與目前選擇之選項ID完全相符，則紀錄異動價錢
      if (matchCount == changeIDList.length) {
        changePrice += parseInt(changeItem.ChangePrice);
      }
    });

    // 返回三種價格：1.原價+異動價格 2.售價+異動價格 3.會員價+異動價格
    return [
      parseInt(shopCartItem.productData.CustomGoodsStock[0].Price) +
        changePrice,
      parseInt(shopCartItem.productData.CustomGoodsStock[0].SellPrice) +
        changePrice,
      parseInt(shopCartItem.productData.CustomGoodsStock[0].MemberSellPrice) +
        changePrice,
    ];
  },
  // 取得一般商品價錢
  productPrice: () => (product) => {
    let stocks = product.Stock.filter(
      (item) => item.Stock > 0 && item.Status == "Y"
    );
    // find the stock with the lowest price
    let minPrice = Math.min(...stocks.map((item) => parseInt(item.SellPrice)));
    return stocks.find((item) => item.SellPrice == minPrice);
  },
  // 價錢文字格式化
  moneyFormat: () => (price) => {
    let val = (price / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  // 取得欄位資料
  columnData: (state) => (columnID) => {
    if (state.commonColumnData == null) {
      return "";
    }
    const column = state.commonColumnData.find(
      (item) => item.ColumnKey == columnID
    );

    return column ? column.Content : "";
  },
};
